import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { QuantitySelector } from '@grandvisionhq/common';
import { pushSolutionsChangeQuantityEvent } from '@grandvisionhq/fun-products';
import { StockIndicator } from '@grandvisionhq/inventory';
import { useIntl } from '@grandvisionhq/state';
import { getCalculatedMaximumQuantity } from '@grandvisionhq/utils';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';
import { useSolutionsEcommContext } from '../../context/SolutionsEcommContext.js';

const DEFAULT_SOLUTION_MAX_QUANTITY = 5;
const SolutionsQuantityAndStock = ({ selectedQuantity , onQuantityChange , isOrderable  })=>{
    const { getLabel  } = useIntl();
    const { activeVariant , clAndSolutionsMaxOrderableQuantity  } = useProductDetailContext();
    const { state  } = useSolutionsEcommContext();
    const { purchaseType  } = state.configurations;
    if (!CommerceToolsApi.isSolutions(activeVariant)) {
        return null;
    }
    const { allowBackOrder , availability , channelAvailability  } = activeVariant;
    var ref;
    const availableQuantity = (ref = availability === null || availability === void 0 ? void 0 : availability.availableQuantity) !== null && ref !== void 0 ? ref : 0;
    const maxOrderableQuantity = clAndSolutionsMaxOrderableQuantity !== null && clAndSolutionsMaxOrderableQuantity !== void 0 ? clAndSolutionsMaxOrderableQuantity : DEFAULT_SOLUTION_MAX_QUANTITY;
    const maxSelectableQuantity = getCalculatedMaximumQuantity(maxOrderableQuantity, availableQuantity, allowBackOrder);
    const onIncreaseQuantity = React.useCallback(()=>{
        const quantity = selectedQuantity + 1;
        onQuantityChange(quantity);
        pushSolutionsChangeQuantityEvent({
            quantity,
            quantityChange: 'increase',
            purchaseType
        });
    }, [
        selectedQuantity,
        purchaseType,
        activeVariant
    ]);
    const onDecreaseQuantity = React.useCallback(()=>{
        const quantity = selectedQuantity - 1;
        onQuantityChange(quantity);
        pushSolutionsChangeQuantityEvent({
            quantity,
            quantityChange: 'decrease',
            purchaseType
        });
    }, [
        selectedQuantity,
        purchaseType,
        activeVariant
    ]);
    if (!isOrderable) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "solutions-quantity-and-stock"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "solutions-quantity-and-stock__label"
    }, getLabel('products.solutions.selectAmount')), /*#__PURE__*/ React.createElement("div", {
        className: "solutions-quantity-and-stock__wrapper"
    }, /*#__PURE__*/ React.createElement(QuantitySelector, {
        quantity: selectedQuantity || 1,
        minimumQuantity: 1,
        maximumQuantity: maxSelectableQuantity,
        onDecreaseQuantity: onDecreaseQuantity,
        onIncreaseQuantity: onIncreaseQuantity,
        isDisabled: !isOrderable
    }), /*#__PURE__*/ React.createElement(StockIndicator, {
        stockCount: availableQuantity,
        allowBackOrder: isOrderable,
        channelAvailability: channelAvailability
    })));
};

export { SolutionsQuantityAndStock };
//# sourceMappingURL=SolutionsQuantityAndStock.js.map
